import { callAPI, HTTPMethod } from "./API";
import { BankAccountEnterprise } from "../model/BankAccountEnterprise";

export async function getBankAccountEnterprise(rfc: string): Promise<BankAccountEnterprise> {
    return await callAPI(`/bank-acccount-enterprise/${rfc}`, {
        method: HTTPMethod.GET
    });
}
